import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-100">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-101" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center relative z-10" data-id="element-102">
        {/* Text Content */}
        <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-103">
          <FadeIn delay={0.1} data-id="element-104">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-slate border border-brand-charcoal text-brand-gold text-sm font-semibold tracking-wider mb-6" data-id="element-105">
              EL CÓDIGO DEL SILENCIO
            </span>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-106">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-107">
              El Protocolo Invisible para que tu hijo adolescente te escuche{' '}
              <span className="text-brand-gold italic" data-id="element-108">
                (sin tener que gritar)
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-109">
            <h2 className="text-xl md:text-2xl text-brand-gray/90 font-light leading-relaxed mb-10" data-id="element-110">
              Recupera el respeto en tu hogar y detén las peleas constantes en
              menos de 7 días, incluso si sientes que ya "perdiste el control".
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-111">
            <CTAButton text="SÍ, QUIERO RECUPERAR LA PAZ EN MI CASA" href="#offer" className="w-full sm:w-auto" data-id="element-112" />
            <p className="mt-4 text-sm text-brand-gray/60 flex items-center justify-center lg:justify-start gap-2" data-id="element-113">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-114" />
              Acceso instantáneo. Pago 100% seguro.
            </p>
          </FadeIn>
        </div>

        {/* Image Mockup */}
        <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-116">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-gold/20 to-transparent blur-3xl -z-10 rounded-full" data-id="element-117" />
            <img src="https://cdn.magicpatterns.com/uploads/jQ14ys2JkaAnStb8pBzoos/Mockup_page.png" alt="El Código del Silencio eBook en Tablet y Teléfono" className="w-full max-w-md lg:max-w-lg object-contain drop-shadow-2xl" data-id="element-118" />
          </motion.div>
        </div>
      </div>
    </section>;
}